<template>
    <WizardShell :mission="mission">
        <!-- Plaque immat -->
        <div class="row pt-1 mb-5 d-flex justify-content-center">
            <div class="col-auto">
                <MissionPlateSection :mission="mission" @addPlate="$emit('addPlate', $event)"
                    @removePlate="$emit('removePlate', $event)" />
            </div>
        </div>
        <template #actions>
            <ButtonDisplay @click="finish" :type="'start'" text="Terminer" />
        </template>
    </WizardShell>
</template>

<script>
import WizardShell from './WizardShell.vue'
import MissionPlateSection from '@/views/Missions/Components/MissionPlateSection.vue'
import ButtonDisplay from '@/components/display/ButtonDisplay.vue'
import MissionService from '@/services/mission.service'

export default {
    name: 'WizardPlates',
    props: ['mission'],
    components: { WizardShell, MissionPlateSection, ButtonDisplay },
    methods: {
        async finish() {
            try {
                // Si la mission est en DRAFT, on appelle endDraft pour passer en PENDING.
                if (this.mission?.status === 'DRAFT') {
                    await MissionService.endDraft(this.mission.id);
                }
                // Sinon (déjà PENDING, etc.), on n’appelle rien et on va à la page mission.
            } catch (e) {
                // Remonte l’erreur lisible si besoin
                const msg = e?.response?.data?.message || e.message || 'Erreur lors de la finalisation.';
                alert(msg);
            } finally {
                // Dans tous les cas on redirige vers la page d’info mission
                if (this.mission?.id) {
                    this.$router.push({ name: 'MissionInfo', params: { id: this.mission.id } });
                }
            }
        }
    }
}
</script>